import React from 'react';
import { BasicButton, TextInput } from '../../UI';
import LoggedLayoutRoot from './LoggedLayoutRoot';
import { primary } from '../../styles/colors';

const SearchIdCouncil = () => {
	const [idCouncilSearch, setIdCouncilSearch] = React.useState(0);
	const [error, setError] = React.useState('');
	const [loading, setLoading] = React.useState(false);

	const goToId = async () => {
		if (!(parseInt(idCouncilSearch, 10) > 2147483647)) {
			if (!Number.isNaN(idCouncilSearch) || idCouncilSearch !== 0) {
				setError('');
				window.location.replace(`${window.location.origin}/rootportal/${idCouncilSearch}`);
				setLoading(false);
			}
		} else {
			setError('Introduzca una id correcta');
		}
	};

	return (
		<LoggedLayoutRoot
			title={'Buscar portal'}
		>
			<div
				style={{
					marginLeft: '2em',
				}}>
				<div>
					<h2 style={{
						color: primary,
						fontSize: '18px',
						fontWeight: '700',
						marginBottom: '0.6em'
					}}>
						Id de reunión:
					</h2>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<TextInput
								type='number'
								value={idCouncilSearch === 0 ? '' : idCouncilSearch}
								disableUnderline={true}
								styles={{ fontWeight: 'bold', width: '300px' }}
								styleInInput={{ backgroundColor: '#ececec', paddingLeft: '5px', border: !!error && '2px solid red' }}
								onKeyUp={event => {
									if (event.keyCode === 13) {
										goToId(event);
									}
								}}
								onChange={event => setIdCouncilSearch(event.target.value)}
							/>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', marginTop: '6px' }}>
							<BasicButton
								text={<i className={loading ? 'fa fa-circle-o-notch fa-spin' : 'fa fa-search'} style={{ color: 'black' }} />}
								onClick={goToId}
								backgroundColor={{
									backgroundColor: 'white',
									minWidth: '0',
									marginLeft: '1em',
									minHeight: '0px',
									boxShadow: 'none',
									borderRadius: '4px',
									border: ' 1px solid black'
								}}
							/>
						</div>
						{error &&
							<div style={{
								display: 'flex',
								alignItems: 'center',
								marginTop: '6px',
								marginLeft: '15px',
								color: 'red',
								fontWeight: 'bold'
							}}>
								{error}
							</div>
						}
					</div>
				</div>
			</div>
		</LoggedLayoutRoot>
	);
};


export default SearchIdCouncil;
